import { computed, Directive, input } from '@angular/core';
import { BrnToggle } from '@spartan-ng/brain/toggle';
import { hlm } from '@spartan-ng/helm/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ClassValue } from 'clsx';

export const toggleVariants = cva(
  'px-md component-medium-semibold focus-visible:!outline-components-focu focus-visible:!bg-components-background-neutral-lightest gap-xs inline-flex cursor-pointer items-center justify-center rounded-md bg-transparent py-[10px] whitespace-nowrap outline-1 focus-visible:outline-2 [&_ng-icon]:pointer-events-none [&_ng-icon]:shrink-0',
  {
    variants: {
      variant: {
        primary:
          'data-[state=on]:outline-stroke-neutral-medium data-[state=on]:text-components-content-neutral-secondary data-[state=off]:text-components-content-primary-main data-[state=on]:hover:bg-components-background-neutral-lighter outline-stroke-primary-main hover:bg-components-background-neutral-lighter hover:outline-color-stroke-primary-darker hover:bg-components-background-primary-lightest hover:outline-2',
        neutral: '',
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  },
);
export type ToggleVariants = VariantProps<typeof toggleVariants>;

@Directive({
  selector: 'button[hlmToggle]',
  hostDirectives: [
    {
      directive: BrnToggle,
      inputs: ['id', 'value', 'disabled', 'state', 'aria-label', 'type'],
      outputs: ['stateChange'],
    },
  ],
  host: {
    'data-slot': 'toggle',
    '[class]': '_computedClass()',
  },
})
export class HlmToggle {
  public readonly variant = input<ToggleVariants['variant']>('primary');
  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    hlm(
      toggleVariants({
        variant: this.variant(),
      }),
      this.userClass(),
    ),
  );
}
